import request from '@/utils/request.js'
import qs from 'qs'

// 获取密码令牌
export function getPasswordEncryptTicket (data) {
  return request({
    url: '/oauth/api/password_token?timestamp=' + new Date().getTime(),
    method: 'get'
  })
}

// 账号密码登录
export function loginWithUserPassword (data) {
  return request({
    url: '/ajax_logon',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    returnRawData: true
  })
}

// 获取Kaptcha图片
export function getKaptchaImage (ticket) {
  return request({
    url: '/kaptcha/image?ticket=' + ticket,
    method: 'GET',
    responseType: 'blob'
  })
}

// 获取应用服务端信息
export function getAppServerSideInfo (showErrorMessage) {
  return request({
    url: '/version',
    method: 'GET',
    showErrorMessage: showErrorMessage
  })
}

// 获取已登录用户名
export function getLoggedUserinfo (showErrorMessage) {
  return request({
    url: '/logged/userinfo',
    method: 'GET',
    showErrorMessage: showErrorMessage
  })
}

// 获取缺省页面
export function getLoggedDefaultURL (showErrorMessage) {
  return request({
    url: '/logged/default',
    method: 'GET',
    showErrorMessage: showErrorMessage
  })
}

// 获取服务端信息
export function getAppPublicConfigs (showErrorMessage) {
  return request({
    url: '/configs',
    method: 'GET',
    showErrorMessage: showErrorMessage
  })
}

// 匿名发送用户验证码
export function sendUserVerifyCode (data, showErrorMessage) {
  return request({
    url: '/send_verify',
    method: 'POST',
    data: qs.stringify(data),
    showErrorMessage: showErrorMessage
  })
}

// 匿名修改用户密码
export function changeUserPassword (data, showErrorMessage) {
  return request({
    url: '/change_password',
    method: 'POST',
    data: qs.stringify(data),
    showErrorMessage: showErrorMessage
  })
}

// 获取OAuth2渠道名称
export function getOAuth2ChannelNames (showErrorMessage) {
  return request({
    url: '/oauth/api/channel_names',
    method: 'GET',
    showErrorMessage: showErrorMessage
  })
}

// 获取扫码登录发起地址（二维码）
export function getOAuth2QRCodeLoginEvent (showErrorMessage) {
  return request({
    url: '/oauth/api/token?type=0',
    method: 'GET',
    showErrorMessage: showErrorMessage
  })
}

// 获取扫码事件状态
export function getOAuth2QRCodeLoginStatus (ticket, showErrorMessage) {
  return request({
    url: '/oauth/api/wait_event?type=0&ticket=' + ticket,
    method: 'GET',
    showErrorMessage: showErrorMessage
  })
}

// 重新加载Kaptcha
export function reloadKaptchaTicket (username) {
  return request({
    url: '/send_verify',
    method: 'POST',
    data: qs.stringify({
      username: username,
      verify_type: 'kaptcha'
    })
  })
}

// 获取通过织语集成登录的单点登录令牌
export function getZhiYuSSOToken (data) {
  return request({
    url: '/zhiyu/auth/token',
    method: 'POST',
    data: data,
    showErrorMessage: false
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js